import { render, staticRenderFns } from "./addGroupUser.vue?vue&type=template&id=6faf9f92&scoped=true"
import script from "./addGroupUser.vue?vue&type=script&lang=js"
export * from "./addGroupUser.vue?vue&type=script&lang=js"
import style0 from "./addGroupUser.vue?vue&type=style&index=0&id=6faf9f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faf9f92",
  null
  
)

export default component.exports